<template>
	<div>
		<el-card class="box-card" shadow="always">
			<div slot="header" class="clearfix">
				<span>考试分类</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="append()">新增一级分类</el-button>
			</div>
			<div class="block">
				<el-tree :data="maintaintype" node-key="maintaintype.id" accordion>
					<!-- default-expand-all默认全部展开  :expand-on-click-node="false"只能点图标才能展开 accordion是否每次只打开一个同级树节点展开 -->
					<span class="custom-tree-node" slot-scope="{ data }">
						<!-- v-for='(item,index) in maintaintype' :key="index" -->
						<span>{{ data.Name }}</span>
						<span>
							<!--增加分类-->
							<i @click="() => append(data)" class="el-icon-plus" v-if="data.Type==1||data.Type==2"></i>&nbsp;
							<!--删除分类-->
							<el-popconfirm confirmButtonText='好的' cancelButtonText='不用了' icon="el-icon-info" iconColor="red" title="该分类下不能有子分类,试题,试卷,确定删除吗？"
								@onConfirm=" deletes(data)">
								<i v-if="data.id !== 0" class="el-icon-delete" slot="reference"></i>
							</el-popconfirm>&nbsp;
							<!--重命名分类-->
							<i v-if="data.id !== 0" @click="() => rename(data)" class="el-icon-edit-outline"></i>

						</span>
					</span>
				</el-tree>
			</div>
		</el-card>
	</div>
	<!--  <el-card class="box-card" shadow="never">
    <div slot="header" class="clearfix">
      <span>操作分类</span>
      <el-button style="float: right; padding: 3px 0" type="text">新增一级分类</el-button>
    </div>
    <div class="block">
      <el-tree :data="data" node-key="id" default-expand-all :expand-on-click-node="false">
        <span class="custom-tree-node" slot-scope="{ node, data }">
          <span>{{ node.label }}</span>
          <span>
            <el-button type="text" size="mini" @click="() => append(data)">
              新增子类
            </el-button>
            <el-button type="text" size="mini" @click="() => remove(node, data)">
              删除
            </el-button>
          </span>
        </span>
      </el-tree>
    </div>
  </el-card> -->
</template>

<script>
import { mapGetters } from 'vuex'
	// let id = 1000
	export default {
		// inject: ['reload'],
		data() {
			return {
				// data2: JSON.parse(JSON.stringify(maintaintype)),
				maintaintype: [
					/* {
					          id: '',
					          name: '',
					          pid: '',
					          type: '',
					          createPeople: '',
					          operPeople: '',
					          children: []
					        } */
				],

			}
		},
		computed: {
      ...mapGetters({ staffId: 'staffId' })
    },
		mounted() {
			this.getExamTypeList()
		},
		methods: {
			/* 查询类型列表 */
			getExamTypeList() {
				let loading = this.$loading()
				this.$get(`Exam_Type/selectAllList?gardenId=${this.$store.getters.gardenId}`)
					.then(response => {
						this.maintaintype = response.list
						loading.close()
						// console.log(this.maintaintype)
						// console.log(JSON.parse(JSON.stringify( response.data.list)));
					})
					.catch(error => {
						console.log(error)
						loading.close()
					})
			},
			append(data) {
				let loading = this.$loading()
				// console.log(data,'增加')
				this.$prompt('', '新增分类', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					// inputPattern: /^[\u4e00-\u9fa5]{0,}$/, //匹配全中文
					// inputErrorMessage: '请输入中文', //不符合正则匹配的提示语句
					inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
						if (!value) {
							return '输入不能为空'
						}
					}

				}).then(({
					value
				}) => {
					var params = {}
					if (data == null || data == '' || data == undefined) {
						params = {
							pid: 0,
							type: 1,
							name: value,
							createPeople: this.staffId,
							operPeople: this.staffId,
							gardenId: this.$store.getters.gardenId
						}
					} else {
						params = {
							pid: data.Id,
							type: (data.Type) + 1,
							name: value,
							createPeople: this.staffId,
							operPeople: this.staffId
						}
					}

			this.$get(`/groupsByGardenId/` +this.$store.getters.gardenId).then(
								res => {
									if (res.list.length > 0) {
												
										this.$postJson('/Exam_Type/add', params)
																.then(response => {
																	this.$message({
																		type: 'success',
																		message: '添加成功'
																	})
																	this.getExamTypeList()
																	loading.close()
																	// this.partialRefresh(data)
																	// this.reload()
																})
																.catch(error => {
																	console.log(error)
																	this.$message({
																		type: 'info',
																		message: '添加失败'
																	})
																	this.getExamTypeList()
																	loading.close()
																})

									} else {
										loading.close()
										this.$message.error(this.$i18n.t('此小区未设置集团，请先设置集团。'))
									}
								},
								err => {
									loading.close()
									this.$message.error(err)
								})


				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消添加'
					})
					loading.close()
				})
			},
			deletes(data) {
				if (data.children != undefined && data.children != null && data.children[0] != undefined && data.children[0] !=
					null) {
					this.$notify({
						title: '提示',
						message: '删除分类时，该分类下不能有子分类',
						type: 'warning'
					})
				} else {
					/* 三次查询  不允许分类下存在试题、试卷 */
					// var params = new URLSearchParams()
					// params.append('questionClass', data.Id)
					let params = {
						'questionClass': data.Id
					}
let loading = this.$loading()
					this.$post('Exam_Question/selectAllNotOption', params)
						.then(response => {
							var eqData = response.list.rows
							// console.log(response.data.list.rows.length)
							/* 逻辑删除：不能判断长度是否为0    以后得改！  直接删除不行 */
							var isDel = 0
							for (let i = 0; i < eqData.length; i++) {
								if (eqData[i].state == 1) {
									isDel = 1
								}
							}

							// if (eqData.length != 0) {
							if (isDel != 0) {
								this.$notify({
									title: '提示',
									message: '该分类下存在试题，删除失败',
									type: 'warning'
								})
								loading.close()
							} else {
								// var params = new URLSearchParams()
								// params.append('paperType', data.Id)
								// params.append('pageNo', 1)
								// params.append('pageSize', 99)
								let params = {
									'paperType': data.Id,
									'pageNo': 1,
									'pageSize': 99
								}
								this.$post('Exam_Paper/select', params)
									.then(response => {
										// console.log(response.data.list)
										if (response.list.list != null) {
											this.$notify({
												title: '提示',
												message: '该分类下存在试卷，删除失败',
												type: 'warning'
											})
											loading.close()
										} else {
											this.$postJson('/Exam_Type/del', {
													id: data.Id
												})
												.then(res => {
													// this.reload()
													this.$message.success('删除成功')
													this.getExamTypeList()
													loading.close()
												})
												.catch(err => {
													console.log(err)
													this.$message.error('未知原因，删除失败')
													this.getExamTypeList()
													loading.close()
												})
										}
									})
									.catch(error => {
										console.log(error)
										loading.close()
									})
							}
						})
						.catch(error => {
							console.log(error)
							loading.close()
						})
				}
				/*
				const parent = node.parent;
				const children = parent.data.children || parent.data;
				const index = children.findIndex(d => d.id === data.id);
				children.splice(index, 1);
				 */
			},
			rename(data) {
				let loading = this.$loading()
				this.$prompt('', '修改分类', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					// inputPattern: /^[\u4e00-\u9fa5]{0,}$/, //匹配全中文
					// inputErrorMessage: '请输入中文', //不符合正则匹配的提示语句
					inputValidator: (value) => { // 点击按钮时，对文本框里面的值进行验证
						if (!value) {
							return '输入不能为空'
						}
					}

				}).then(({
					value
				}) => {
					var params = {
						id: data.Id,
						name: value,
						operPeople: this.staffId
					}
					// console.log(params)
					this.$postJson('/Exam_Type/update', params)
						.then(response => {
							this.$message({
								type: 'success',
								message: '修改成功'
							})
							this.getExamTypeList()
							loading.close()
							// this.partialRefresh(data)
							// this.reload()
						})
						.catch(error => {
							console.log(error)
							this.$message({
								type: 'info',
								message: '修改失败'
							})
							this.getExamTypeList()
							loading.close()
						})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消修改'
					})
					this.getExamTypeList()
					loading.close()
				})
			}
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}
	
	.text {
		font-size: 14px;
	}
	
	.item {
		margin-bottom: 18px;
	}
	
	.clearfix:after {
		clear: both
	}
	
	.box-card {
		margin: 0 auto;
	
		width: 680px;
	}
	
	.el-card {
		padding: 10px;
		border-radius: 6px;
		background-color: #fff;
	
		.el-card__header {
			text-align: left;
			padding: 20px;
			border: none;
			border-bottom: 1px solid #ebeef5;
	
			.el-button {
				padding: 10px 30px;
			}
		}
	
		.el-card__body {
			padding: 20px;
		}
	}
</style>
